import React, { FunctionComponent } from 'react';
import Image from 'next/image';

type Props = {
    title: string,
    url: string
}

const SharePage: FunctionComponent<Props> = ({title,url}) => {
    
    return (
        <div className='text-base my-6 md:mt-0 md:mb-8'>
            <div className='flex items-center justify-start'>
                <span className='inline-block body-small align-middle'>Share this page</span>
                <div className='pl-5 md:pl-2 lg:pl-5'>
                    <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`} rel='noopener noreferrer' target='_blank'>
                        <Image 
                            src='/icons/linkedin.png'
                            alt='Linkedin'
                            width={48}
                            height={48}
                        />
                    </a>
                </div>
                <div className='pl-5 md:pl-2 lg:pl-5'>
                    <a href={`https://twitter.com/share?via=sponsorpulse&url=${url}&title=${title}`} rel='noopener noreferrer' target='_blank'>
                        <Image 
                            src='/icons/twitter.png'
                            alt='Twitter'
                            width={48}
                            height={48}
                        />
                    </a>
                </div>
                <div className='pl-5 md:pl-2 lg:pl-5'>
                    <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} rel='noopener noreferrer' target='_blank'>
                        <Image 
                            src='/icons/facebook.png'
                            alt='Facebook'
                            width={48}
                            height={48}
                        />
                    </a>
                </div> 
            </div>
        </div>
    )
};

export default SharePage;